<template>
  <form>
    <div v-if="formSettings.header" class="header">{{formSettings.header}}</div>
    <div v-for="(f, index) in forms" :key="index" class="box">
      <InputHidden v-if="f.type==='hidden'" :name="index" :default="f.default"/>
      <div v-else class="span">
        <span class="head">{{f.label}}</span>
        <span v-if="f.type==='view' || isView" class="view">
          <span v-if="f.value === null" class="no-data">no data.</span>
          <span v-else-if="f.type==='select'">{{selectField(f)}}</span>
          <span v-else-if="f.type==='date'">{{dateFormat(f.value)}}</span>
          <span v-else class="detail">{{f.value}}</span>
        </span>
        <InputText v-else-if="f.type==='text'" :name="index" :size="f.option.size" :placeholder="f.placeholder"
                   :default="f.default" :isError="validationErrors[index]" class="form-item"/>
        <InputText v-else-if="f.type==='password'" :name="index" :size="f.option.size" :placeholder="f.placeholder"
                   :default="f.default" :isError="validationErrors[index]" :isPassword="true" class="form-item"/>
        <DateForm v-else-if="f.type==='date'" :name="index" :default="f.default" :option="f.option"/>
        <InputTextArea v-else-if="f.type==='textArea'" :name="index" :size="f.option.size" :placeholder="f.placeholder"
                       :default="f.default" :isError="validationErrors[index]" class="form-item"/>
        <SelectForm v-else-if="f.type==='select'" :name="index" :data="f.options" :default="f.default"
                    class="form-item"/>
        <CheckBoxObject v-else-if="f.type==='checkbox'" :name="index" :options="f.options" :default="f.default"
                        class="form-item"/>
        <div v-else-if="f.type==='view-hidden'" class="span">
          {{f.value}}
          <InputHidden :name="index" :default="f.default"/>
        </div>
        <span v-else class="unknown">Unknown form type: {{f.type}}</span>
      </div>
      <div :class="classNoValidationErrorMessage" class="validation-error-message">{{errorMessages[index]}}</div>
    </div>

    <div v-if="isNew" class="create-button-container">
      <div class="submit-2button-left-container">
        <div @click="cancelAction" class="cancel">
          <Button :label="cancel.label" :color="cancel.color" :isForm="true"/>
        </div>
        <div @click="apiRequestAction" class="submit">
          <Button :label="submit.label" :icon="submit.icon" :color="submit.color" :isForm="true"/>
        </div>
      </div>
    </div>
    <div v-else-if="!isView">
      <div v-if="formSettings.use2Button" class="submit-2button-container">
        <div>
          <div @click="deleteAction" class="delete">
            <Button :label="del.label" :color="del.color" :isForm="true"/>
          </div>
        </div>
        <div class="submit-2button-left-container">
          <div @click="cancelAction" class="cancel">
            <Button :label="cancel.label" :color="cancel.color" :isForm="true"/>
          </div>
          <div @click="apiRequestAction" class="submit">
            <Button :label="submit.label" :icon="submit.icon" :color="submit.color" :isForm="true"/>
          </div>
        </div>

      </div>
      <div v-else @click="apiRequestAction" class="submit-button-container">
        <Button :label="submit.label" :icon="submit.icon" :color="submit.color" :isForm="true"/>
      </div>

      <div class="message">{{message}}</div>
    </div>

    <div v-if="showInformation" class="information">
      <div v-for="(info, index) in formSettings.info" :key="'info'+index">
        {{info}}
      </div>
    </div>
  </form>
</template>

<script>
/**
 *
 * TODO: 対応パターン増やす
 *
 */

import Button from '@/components/button/Button';
import InputText from '@/components/form/InputText';
import CheckBoxObject from '@/components/form/CheckBoxObject';
import InputHidden from '@/components/form/InputHidden';
import SelectForm from '@/components/form/SelectForm';
import InputTextArea from '@/components/form/InputTextArea';
import DateForm from '@/components/form/DateForm';

export default {
  props: ['formSettings'],
  components: {
    Button,
    InputText,
    CheckBoxObject,
    InputHidden,
    SelectForm,
    InputTextArea,
    DateForm
  },
  data () {
    return {
      errors: {
        // TODO: 対応を増やす
        'validation.required': '入力されていません',
        'validation.email': 'メールアドレスを入力してください',
        'validation.min.string': 'パスワードは8文字以上で設定します'
      },
      validation: {
        require: '入力されていません',
        passwordNotMatch: 'パスワードが一致しません'
      },
      lock: false,
      validationErrors: {},
      errorMessages: {},
      forms: {},
      submit: {},
      cancel: {},
      del: {},
      store: 'unknown',
      dispatch: 'unknown',
      message: null
    };
  },
  watch: {
    '$route' () {
      this.initialize();
    },
    lock: function () {
      // ローディング表示
      if (this.lock === true) {
        this.$store.dispatch('loading/open').then();
      } else {
        this.$store.dispatch('loading/close').then();
      }

    }
  },
  created: function () {
    this.initialize();
  },
  destroyed: function () {
    // ローディング止める
    this.$store.dispatch('loading/close').then();
  },
  computed: {
    showInformation: function () {

      if (typeof this.formSettings.info === 'object') {
        if (this.formSettings.info.length >= 1) {
          return true;
        }
      }

      return false;
    },
    classNoValidationErrorMessage: function () {
      if (this.formSettings.noValidationErrorMessage === true) {
        return 'display-none';
      } else {
        return '';
      }
    },
    isView: function () {

      if (typeof  this.formSettings.isView !== 'undefined') {
        if (this.formSettings.isView) {
          return true;
        }
      }

      return false;

    },
    isNew: function () {
      if (typeof  this.formSettings.isNew !== 'undefined') {
        if (this.formSettings.isNew) {
          return true;
        }
      }

      return false;

    }
  },
  methods: {
    initialize: function () {

      this.store = this.formSettings.store;
      this.dispatch = this.formSettings.dispatch;

      this.forms = this.formSettings.forms;

      for (let key in this.forms) {
        console.log(key, this.forms[key].value);

        if (typeof this.forms[key].value === 'undefined') {
          this.forms[key].default = null;
        } else if (this.forms[key].value !== null) {
          this.forms[key].default = this.forms[key].value;
        }
      }

      this.submit = this.formSettings.submit;

      if (typeof this.formSettings.cancel !== 'undefined') {
        this.cancel = this.formSettings.cancel;
      }

      if (typeof this.formSettings.del !== 'undefined') {
        this.del = this.formSettings.del;
      }

      // Form storeの初期化
      this.$store.dispatch('formValues/reset').then();

      this.reset();
    },
    reset: function () {

      for (let key in this.forms) {
        // console.log(this.forms[key]);
        this.validationErrors[key] = false;
        this.errorMessages[key] = null;
      }

    },
    selectField: function (setting) {

      let value = setting.value + '';//to string

      for (let k in setting.options) {
        // console.log(setting.options[k].value, value);

        if (setting.options[k].value === value) {
          return setting.options[k].label;
        }
      }

      return 'unknown';

    },
    deleteAction: function () {
      let dispatcher = 'edit-delete';
      this.$emit('callback', dispatcher, null);
    },
    cancelAction: function () {
      let dispatcher = 'edit-cancel';
      this.$emit('callback', dispatcher, null);
    },
    apiRequestAction: function () {
      console.log('action');

      this.reset();

      this.message = null;

      if (this.lock === true) {
        // console.log('lock', this.lock);
        return;
      }

      let params = this.setParams();
      console.log(params);

      if (this.validationCheck(params) === false) {

        if (this.formSettings.noValidationErrorMessage === true) {
          this.message = '入力内容を確認してください';
        }

        return;
      }

      // ロック
      this.lock = true;

      let dispatch = this.store + '/' + this.dispatch;

      this.$store.dispatch(dispatch, params).then(() => {

        // ロック解除
        this.lock = false;

        let status = this.$store.getters[this.store + '/status'];

        if (status === 200) {

          let dispatcher = 'FormHelperFinish';
          this.$emit('callback', dispatcher, null);

        } else if (status === 209) {

          let reasonCode = this.$store.getters[this.store + '/reasonCode'];

          if (reasonCode === 'VALIDATION_ERROR') {

            // バリデーションメッセージを変換
            this.setValidationMessage();

          } else {

            if (typeof this.formSettings.reasonCode === "undefined") {
              this.message = 'Undefined reason code: ' + reasonCode;
            } else if (typeof this.formSettings.reasonCode[reasonCode] !== "undefined") {
              this.message = this.formSettings.reasonCode[reasonCode];
            } else {

              let dispatcher = 'FormHelperNotice';
              this.$emit('callback', dispatcher, null);

            }

          }

        } else {
          this.$store.dispatch('errorInfo/setErrorStore', this.store).then();

          if (this.$route.meta.mode === 'admin') {
            this.$router.push({name: 'AdminSystemError'});
          } else {
            this.$router.push({name: 'UserSystemError'});
          }

        }

      }).catch((err) => {
        console.warn(err);

        // ロック解除
        this.lock = false;

        this.$store.dispatch('errorInfo/setSystemErrorMessage').then();

        if (this.$route.meta.mode === 'admin') {
          this.$router.push({name: 'AdminSystemError'});
        } else {
          this.$router.push({name: 'UserSystemError'});
        }
      });

    },
    setParams: function () {

      let params = {};

      let formData = this.$store.getters['formValues/formData'];

      for (let key in this.forms) {

        if (typeof formData[key] !== 'undefined') {
          params[key] = formData[key];
        } else {
          if (this.forms[key].type !== 'view') {
            params[key] = null;
          }
        }

      }

      if (this.formSettings.useSessionId === true) {

        let sessionId = null;

        if (this.$route.meta.mode === 'admin') {
          sessionId = this.$store.getters['adminAuth/session'];

        } else {
          sessionId = this.$store.getters['auth/session'];

        }
        params['s'] = sessionId;
      }

      return params;

    },
    validationCheck: function (params) {

      console.log(this.forms, params);
      // console.log(this.validation.require);

      let check = true;

      let ve = {};
      let em = {};

      for (let key in params) {
        console.log(key, this.forms[key]);

        if (typeof this.forms[key] !== 'undefined') {
          // console.log(key, typeof this.forms[key]);

          if (typeof this.forms[key]['require'] !== 'undefined') {
            if (this.forms[key].require === true) {
              console.log(typeof params[key], params[key]);

              if (typeof params[key] === 'undefined' || params[key] === null || params[key] === '') {
                ve[key] = true;
                em[key] = this.validation.require;

                check = false;
              }
            }
          }

          console.log(this.forms[key].validate, typeof this.forms[key].validate);

          if (typeof this.forms[key].validate !== 'undefined') {
            let validate = this.forms[key].validate;

            if (typeof validate === 'object') {
              for (let vk in validate) {
                console.log(vk, validate[vk]);

                if (validate[vk] === 'password_confirmation') {
                  // パスワード一致チェック
                  if (params['password'] !== params[key]) {
                    ve[key] = true;
                    em[key] = this.validation.passwordNotMatch;

                    check = false;
                  }
                }

              }
            }
          }

        }
      }

      this.validationErrors = ve;
      this.errorMessages = em;

      // TODO: 拡張する this.formSettings[key].validate

      console.log(check, this.validationErrors, this.errorMessages);

      return check;
    },
    setValidationMessage: function () {

      let vError = this.$store.getters[this.store + '/validationErrors'];
      // console.log(this.store, vError);

      let _this = this;

      let errorMessages = {};
      Object.keys(vError).forEach(function (index) {
        // console.log(index, vError[index]);

        _this.validationErrors[index] = true;

        let message = _this.convertErrorMessage(vError[index]);
        // console.log(message);

        errorMessages[index] = message;

      });

      this.errorMessages = errorMessages;

    },
    convertErrorMessage: function (messages) {
      // console.log(messages);

      let errors = this.errors;

      let converted = '';
      Object.keys(messages).forEach(function (index) {

        let code = messages[index];

        if (typeof errors[code] !== "undefined") {
          converted = errors[code];
        } else {
          converted = '入力内容を確認してください';
        }

      });

      return converted;

    },
    dateFormat: function (value) {
      // console.log(value);

      if(value === null || value === ''){
        return '';
      }

      let time = Date.parse(value);

      if(isNaN(time)){
        return '';
      }

      let endless = Date.parse('2035-12-31 00:00:00');

      if(time >= endless){
        return '無期限';
      }

      let date = new Date(time);

      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      let h = date.getHours();
      let i = date.getMinutes();

      if (m < 10) {
        m = '0' + m;
      }

      if (d < 10) {
        d = '0' + d;
      }

      if (h < 10) {
        h = '0' + h;
      }

      if (i < 10) {
        i = '0' + i;
      }

      return y + '年' + m + '月' + d + '日 ' + h + '時' + i + '分';
    }
  }
};

</script>

<style lang="scss" scoped>
  .header{
    font-size: 20px;
    color: #444;
  }

  .unknown {
    font-size: 12px;
    color: #f00;
  }

  .span {
    display: inline;
  }

  .no-data {
    color: #aaa;
  }

  .view {
    padding-left: 15px;
  }

  // 801以上
  @media screen and (min-width: 801px) {

    .submit-button-container {
      width: 300px;
      margin: 5px auto;
    }

    .submit-2button-container {
      display: flex;
      justify-content: space-between;

      .submit {
        width: 200px;
        margin-right: 20px;
      }
      .cancel {
        width: 120px;
        margin-left: 10px;
      }
    }

    .create-button-container {
      display: flex;
      justify-content: flex-end;
      margin: 15px 0 15px 0;

      .submit-2button-left-container {
        width: 400px;
        display: flex;
        justify-content: flex-end;

        .submit {
          width: 200px;
          margin-right: 20px;
        }
        .cancel {
          width: 120px;
          margin-right: 20px;
        }
      }
    }

    .detail {
      white-space: pre-wrap;
    }

  }

  // 800まで
  @media screen and (max-width: 800px) {

    .submit-button-container {
      width: 80%;
      margin: 20px auto;
    }

    .submit-2button-container {
      display: flex;
      justify-content: space-between;

      .submit {
        width: 200px;
        margin-right: 20px;
      }
      .cancel {
        width: 120px;
        margin-left: 10px;
      }
    }

    .create-button-container {
      display: flex;
      justify-content: flex-end;
      margin: 15px 0 15px 0;

      .submit-2button-left-container {
        width: 400px;
        display: flex;
        justify-content: flex-end;

        .submit {
          width: 200px;
          margin-right: 20px;
        }
        .cancel {
          width: 120px;
          margin-right: 20px;
        }
      }
    }

    .detail {
      white-space: pre-wrap;
    }
  }

</style>
